import React, { useState } from "react";
import FrontHeader from "../../shared/FrontHeader/FrontHeader";
import FrontFooter from "../../shared/FrontFooter/FrontFooter";
import FrontMainNav from "../../shared/FrontMainNav/FrontMainNav";
import { FiShoppingCart, FiClock, FiTruck } from "react-icons/fi";

const CONTACT_EMAIL = "allintechsn@gmail.com";
const FORMSPREE_ENDPOINT = (typeof process !== "undefined" && process.env?.REACT_APP_FORMSPREE_CONTACT_ID)
  ? `https://formspree.io/f/${process.env.REACT_APP_FORMSPREE_CONTACT_ID}`
  : null;

function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    message: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<"idle" | "success" | "error">("idle");

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setSubmitStatus("idle");
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus("idle");

    if (FORMSPREE_ENDPOINT) {
      try {
        const res = await fetch(FORMSPREE_ENDPOINT, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            _replyto: formData.email,
            nom_et_prenom: formData.name,
            telephone: formData.phone,
            email: formData.email,
            message: formData.message,
          }),
        });
        if (res.ok) {
          setSubmitStatus("success");
          setFormData({ name: "", phone: "", email: "", message: "" });
        } else {
          setSubmitStatus("error");
        }
      } catch {
        setSubmitStatus("error");
      }
      setIsSubmitting(false);
      return;
    }

    const subject = encodeURIComponent(
      `Contact depuis le site - ${formData.name || "Sans nom"}`
    );
    const body = encodeURIComponent(
      `Nom et prénom: ${formData.name}\nTéléphone: ${formData.phone}\nEmail: ${formData.email}\n\nMessage:\n${formData.message}`
    );
    window.location.href = `mailto:${CONTACT_EMAIL}?subject=${subject}&body=${body}`;
    setIsSubmitting(false);
  };

  return (
    <div className="landing-page-component">
      <FrontHeader />
      <div className="page-content contact-page-content">
        <FrontMainNav />
        <div className="contact-page-container">
          <section className="contact-form-section">
            <h2 className="contact-form-title">Formulaire de contact</h2>
            <form
              className="contact-form"
              onSubmit={handleSubmit}
              noValidate
            >
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Nom et prénom"
                className="contact-form-input"
                aria-label="Nom et prénom"
              />
              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                placeholder="Téléphone"
                className="contact-form-input"
                aria-label="Téléphone"
              />
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Email"
                className="contact-form-input"
                aria-label="Email"
              />
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                placeholder="Message"
                className="contact-form-textarea"
                rows={6}
                aria-label="Message"
              />
              <button
                type="submit"
                className="contact-form-submit"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Envoi..." : "ENVOYER"}
              </button>
              {submitStatus === "success" && (
                <p className="contact-form-success" role="status">
                  Message envoyé. Nous vous recontacterons rapidement.
                </p>
              )}
              {submitStatus === "error" && (
                <p className="contact-form-error" role="alert">
                  L&apos;envoi a échoué. Réessayez ou envoyez-nous un email à {CONTACT_EMAIL}.
                </p>
              )}
            </form>
          </section>
        </div>

        <section className="contact-guarantees-section" aria-label="Garanties de service">
          <div className="contact-guarantees-inner">
            <div className="contact-guarantee-block">
              <FiShoppingCart className="contact-guarantee-icon" aria-hidden="true" />
              <span className="contact-guarantee-label">Commandes 24h/24</span>
            </div>
            <div className="contact-guarantee-divider" aria-hidden="true" />
            <div className="contact-guarantee-block">
              <FiClock className="contact-guarantee-icon" aria-hidden="true" />
              <span className="contact-guarantee-label">Disponible 7j/7</span>
            </div>
            <div className="contact-guarantee-divider" aria-hidden="true" />
            <div className="contact-guarantee-block">
              <FiTruck className="contact-guarantee-icon" aria-hidden="true" />
              <span className="contact-guarantee-label">Livraison partout</span>
            </div>
          </div>
        </section>
      </div>
      <FrontFooter />
    </div>
  );
}

export default Contact;
